// Weergave van een gesprek in de kolom 'Eerdere gesprekken' van de Offerte Generator.
// Alleen weergave: de opgeslagen titel blijft ongewijzigd. Klant, offertenummer en
// onderwerp komen uit de lijst-endpoint (company_name / offer_number / subject).

const SCHEIDER = ' · ';

export const GESPREKKEN_BREEDTE = { standaard: 340, min: 260, max: 560 };

// Titels die niets zeggen over welke offerte het is: de bron-intro, of de terugvaltitels.
export function isNietszeggendeTitel(titel) {
  const t = String(titel || '').replace(/\s+/g, ' ').trim().toLowerCase();
  if (!t) return true;
  if (t.startsWith('hier is de bron')) return true;
  return t === 'offerte' || t === 'offerte (concept)' || t === 'nieuwe offerte';
}

const normaal = (s) => String(s || '').replace(/\s+/g, ' ').trim();

// Haal een herhaalde klantnaam vooraan de titel weg ("Fontys · Portvolio" → "Portvolio").
function zonderKlantVooraan(tekst, klant) {
  if (!klant) return tekst;
  const lager = tekst.toLowerCase();
  const k = klant.toLowerCase();
  if (!lager.startsWith(k)) return tekst;
  const rest = tekst.slice(klant.length).replace(/^[\s·\-–—:|,]+/, '');
  return rest || tekst;
}

// { titel, volledig }: titel voor de lijst, volledig voor de tooltip.
export function gesprekWeergave(c) {
  const origineel = normaal(c?.title);
  const klant = normaal(c?.company_name);
  const nummer = normaal(c?.offer_number);
  const onderwerpRaw = isNietszeggendeTitel(origineel) ? normaal(c?.subject) : origineel;
  // Zonder klant, nummer en bruikbaar onderwerp blijft de huidige titel staan.
  if (!klant && !nummer && !onderwerpRaw) {
    const t = origineel || 'Offerte';
    return { titel: t, volledig: t };
  }
  let onderwerp = zonderKlantVooraan(onderwerpRaw, klant);
  if (nummer && onderwerp.startsWith(nummer)) onderwerp = onderwerp.slice(nummer.length).replace(/^[\s·\-–—:|,]+/, '');
  const titel = [klant, nummer, onderwerp].filter(Boolean).join(SCHEIDER) || origineel || 'Offerte';
  const volledig = origineel && origineel !== titel && !isNietszeggendeTitel(origineel) && !titel.includes(origineel)
    ? `${titel}\n${origineel}` : titel;
  return { titel, volledig };
}

// Zoeken op titel, klant, offertenummer en onderwerp (alle woorden moeten voorkomen).
export function gesprekMatcht(c, zoekterm) {
  const woorden = normaal(zoekterm).toLowerCase().split(' ').filter(Boolean);
  if (!woorden.length) return true;
  const hooi = [c?.title, c?.company_name, c?.offer_number, c?.subject]
    .map((x) => normaal(x).toLowerCase()).join(' ');
  return woorden.every((w) => hooi.includes(w));
}

export function begrensBreedte(px) {
  const n = Number(px);
  if (!Number.isFinite(n)) return GESPREKKEN_BREEDTE.standaard;
  return Math.min(GESPREKKEN_BREEDTE.max, Math.max(GESPREKKEN_BREEDTE.min, Math.round(n)));
}

const sleutel = (email) => `offerteGenerator.gesprekkenBreedte.${String(email || 'anoniem').toLowerCase()}`;

export function leesGesprekkenBreedte(email) {
  try {
    const v = window.localStorage.getItem(sleutel(email));
    return v == null ? GESPREKKEN_BREEDTE.standaard : begrensBreedte(v);
  } catch {
    return GESPREKKEN_BREEDTE.standaard;
  }
}

export function bewaarGesprekkenBreedte(email, px) {
  try { window.localStorage.setItem(sleutel(email), String(begrensBreedte(px))); } catch { /* alleen gemak */ }
}
